export default "__VITE_ASSET__BicZA6vU__"